import jsonExport from 'jsonexport/dist';
import downloadCSV from './downloadCSV';
var defaultExporter = function (data, _, __, resource) {
    return jsonExport(data, function (err, csv) { return downloadCSV(csv, resource); });
};
export default defaultExporter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/export/defaultExporter.js
// module id = 411
// module chunks = 0